export default function HVACSystemsElPaso() {
  const systems = [
    {
      name: 'Central Air Conditioning',
      description: 'Most popular choice for El Paso homes, providing whole-house cooling with energy-efficient operation.',
      features: ['Whole-home comfort', 'Energy efficient', 'Quiet operation', 'Smart thermostat compatible'],
      image: 'https://public.readdy.ai/ai/img_res/c30ba0bfecb6c51fa7e1c593bbcd5fa6.jpg'
    },
    {
      name: 'Heat Pump Systems',
      description: 'Dual-function systems that provide both heating and cooling, ideal for El Paso\'s moderate winters.',
      features: ['Heating & cooling', 'Lower energy costs', 'Environmentally friendly', 'Year-round comfort'],
      image: 'https://readdy.ai/api/search-image?query=Contemporary%20heat%20pump%20system%20installation%20in%20residential%20setting%2C%20sleek%20modern%20equipment%20with%20clean%20lines%2C%20bright%20natural%20lighting%20highlighting%20energy-efficient%20technology%2C%20professional%20outdoor%20unit%20placement%20with%20minimal%20background%2C%20focus%20on%20dual-function%20HVAC%20system%20quality%20and%20modern%20design&width=500&height=350&seq=hvac-heatpump-001&orientation=landscape'
    },
    {
      name: 'Ductless Mini-Split',
      description: 'Perfect for room additions or homes without ductwork, offering flexible zone control.',
      features: ['No ductwork needed', 'Zone control', 'Easy installation', 'Compact design'],
      image: 'https://readdy.ai/api/search-image?query=Elegant%20ductless%20mini-split%20air%20conditioner%20mounted%20on%20interior%20wall%2C%20modern%20white%20unit%20in%20contemporary%20home%20setting%2C%20clean%20minimalist%20background%20emphasizing%20sleek%20design%2C%20bright%20natural%20lighting%20showing%20compact%20efficient%20cooling%20system%2C%20professional%20installation%20with%20focus%20on%20space-saving%20technology&width=500&height=350&seq=hvac-ductless-001&orientation=landscape'
    },
    {
      name: 'Gas Furnaces',
      description: 'Reliable heating solution for El Paso winters, providing consistent warmth and comfort.',
      features: ['Fast heating', 'Cost-effective', 'Long lifespan', 'Reliable performance'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20gas%20furnace%20installation%20in%20clean%20utility%20room%2C%20modern%20high-efficiency%20heating%20unit%20with%20visible%20quality%20components%2C%20bright%20lighting%20showing%20technical%20precision%2C%20neutral%20background%20emphasizing%20reliable%20heating%20equipment%2C%20focus%20on%20professional%20HVAC%20installation%20craftsmanship&width=500&height=350&seq=hvac-furnace-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Popular HVAC Systems for El Paso Homes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the right heating and cooling system for your home's needs and El Paso's unique climate conditions.
          </p>
        </div>

        <div className="space-y-12">
          {systems.map((system, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-lg overflow-hidden ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } flex flex-col lg:flex`}
            >
              <div className="lg:w-1/2 relative h-80 lg:h-auto">
                <img 
                  src={system.image}
                  alt={system.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="lg:w-1/2 p-10">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {system.name}
                </h3>
                <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                  {system.description}
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {system.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-orange-600 text-xl"></i>
                      <span className="text-gray-700 font-medium">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
